export default "__VITE_ASSET__MiaOlf$m__"